import React, {createContext, useContext, useEffect, useState} from 'react';
import {I18n} from 'react-polyglot-hooks';
import {getMe} from '../graphql/auth';
import langDictionary from './langDictionary.api';
import updateSelf from './updateSelf.api';
import allCmsCopy from './allCmsCopy.api';
import {CmsCopy} from '../graphql/common.datatypes';

interface Phrases {
  [locale: string]: {
    [key: string]: string
  }
}

const LocaleContext = createContext({
  phrases: {} as Phrases,
  locale: 'en',
  //Dummy function needs same signiture as real function used later.
  setLocale: (value: string) => {const i = value;}}
);

export const I18nProvider = (props: { children?: any }) => {
  const [locale, setLocale] = useState('en');
  const [phrases, setPhrases] = useState({} as Phrases);
  const [cmsCopy, setCmsCopy] = useState<CmsCopy[]>([]);
  const meData = getMe();
  const dictionaryData = langDictionary(locale);
  const cmsCopysData = allCmsCopy();
  const [sendUpdateSelf] = updateSelf();

  useEffect(() => {
    if (!phrases[locale] && !dictionaryData.loading) {
      if (dictionaryData.data) {
        const newPhrases = JSON.parse(dictionaryData.data.langDictionary);
        cmsCopy.map(copy => newPhrases[copy.key] = copy.body);
        setPhrases({...phrases, [locale]: newPhrases});
      }
    } else {
      if (cmsCopy.length > 0) {
        const checkCopy = cmsCopy[0];
        if (phrases[locale]) {
          const currentPhrases = phrases[locale];
          if (currentPhrases[checkCopy.key] === undefined) {
            const newPhrases = {...currentPhrases};
            cmsCopy.map(copy => newPhrases[copy.key] = copy.body);
            setPhrases({...phrases, [locale]: newPhrases});
          }
        }
      }
    }

    if (!dictionaryData.loading) {
      const userId = meData.data && meData.data!.me ? meData.data!.me.id : undefined;
      if (userId && (meData.data && meData.data.me.locale !== locale)) sendUpdateSelf({
        variables: {
          data: {
            id: userId,
            locale
          }
        }
      });
    }
  }, [locale, dictionaryData.loading, cmsCopy]);

  useEffect(() => {
    if (cmsCopysData.data && cmsCopysData.data.allCmsCopy) {
      setCmsCopy(cmsCopysData.data.allCmsCopy);
    }
  }, [cmsCopysData.loading])

  useEffect(() => {
    if (!meData.loading && meData.data && meData.data.me) {
      if (meData.data.me.locale !== locale) {
        setLocale(meData.data.me.locale!);
      }
    }
  }, [meData]);

  return (
      <LocaleContext.Provider value={{phrases, locale, setLocale}}>
        <I18n locale={locale} phrases={phrases[locale]}>
          {props.children}
        </I18n>
      </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);

export default I18nProvider;
